const DEV = (() => {
  try {
    const g = globalThis as any;
    if (typeof g.__BW_DEV__ === "boolean") return g.__BW_DEV__;
    if (typeof process !== "undefined" && process.env?.NODE_ENV) {
      return process.env.NODE_ENV !== "production";
    }
    return false;
  } catch {
    return false;
  }
})();

const counters = new Map<string, number>();

export function dev() {
  return DEV;
}

export function nextId(scope: string) {
  if (!DEV) return 0;
  const next = (counters.get(scope) || 0) + 1;
  counters.set(scope, next);
  return next;
}

export function now() {
  return Date.now();
}

export function log(tag: string, payload: Record<string, unknown>) {
  if (!DEV) return;
  try {
    console.debug(tag, payload);
  } catch {
    // ignore logging failures
  }
}
